var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Files")]),_c('v-breadcrumbs',{attrs:{"items":_setup.breadcrumbItems}}),_c(_setup.StoreFileList,{attrs:{"store":_vm.$route.params.store}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }